import { _, moment } from "../../../../../vendor";
import t from "../../../helpers/t";
import { rbac } from "../index";
import { Biscuit } from "../../../../utils";
import { in_array } from "../../../../utils/Helper";
import { insurancesActions, useSelector } from "inbooma-api";
//import * as OrderFunctions from "./behaviors/OrderFunctions";
import InsuranceListItem from "./InsuranceListItem";
import React, { useEffect, useState } from "react";
import { dateFormat, timeFormat } from "../../../../utils/FormatHelper";
import * as OrderFunctions from "../../reservations/components/behaviors/OrderFunctions";

const InsuranceItem = (props) => {
  const { insurance, index, dispatch, currentUrl, showNotification, isAbo } = props;
  let language = Biscuit.get("user.lang").replace("-", "_");
  const searchParams = currentUrl.searchParams;
  const [insuranceLocal, setInsuranceLocal] = useState(insurance);
  const [insurancePending, setInsurancePending] = useState(false);
  const _editInsurance = useSelector((state) => state.insurances_data.editInsurance);

  useEffect(() => {
    if (!insurancePending || _editInsurance.success === "") {
      return;
    }

    if (_editInsurance.success === true) {
      const clone = {};
      Object.assign(clone, insuranceLocal);
      clone.notification_days = _editInsurance.data.notification_days;
      setInsuranceLocal(clone);
      showNotification("success", insuranceLocal.id, "", "insurance");
    } else {
      showNotification(
        "warning",
        null,
        typeof _editInsurance.data.message !== "undefined"
          ? _editInsurance.data.message
          : t("could_not_be_saved_${a}", { a: t("insurance") }, "capital") +
              " #" +
              insuranceLocal.id,
      );
      console.log("Failed patching reservation!");
    }
    setInsurancePending(null);
    // props.filterChangedHandle(props.filter);
  }, [_editInsurance]);

  useEffect(() => {
    fillData();
  }, [insurancePending]);

  const onNotificationDaysChangedHandler = (e, item) => {
    dispatch(
      insurancesActions.editInsurance({
        token: Biscuit.get("token"),
        insurance_id: item.id,
        data: {
          notification_days: e.target.value,
        },
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setInsurancePending(true);
  };

  let insuranceData = null;
  const fillData = () => {
    insuranceData = null;
    let ins;
    let toggle = false;
    ins = insuranceLocal;
    if (
      typeof searchParams.get("item") !== "undefined" &&
      searchParams.get("item") !== null &&
      Number(ins.id) === Number(searchParams.get("item"))
    ) {
      toggle = true;
    }
    let hasCertificates =
      typeof ins.insurance_certificates !== "undefined" &&
      ins.insurance_certificates !== null &&
      ins.insurance_certificates.length > 0;
    let addClasses = "";
    if (toggle) {
      addClasses += " toggled";
    }
    let elements = [];
    elements = [
      {
        type: "text",
        value: "created",
        title: "",
        extraClasses: "inb-order-date",
        data: [
          {
            text: moment(ins.created).format(dateFormat(language, true)),
            value: "created",
            title: t("created"),
          },
        ],
        mediumWidth: 1,
        smallWidth: 2,
      },
      {
        type: "text",
        value: "name",
        title: "",
        extraTopClasses: "",
        data: [
          {
            value: "name",
            text: ins.name,
            extraClasses: "newline",
            title: t("user", null, "capital"),
          },
          {
            value: "user_profile",
            text: t("open_profile"),
            extraClasses: "",
            title: "",
            ref: "users/" + ins.user_id + "?path=/finances/insurances",
          },
        ],
        mediumWidth: 1,
        smallWidth: 2,
      },
      {
        type: "text",
        value: "description",
        title: "",
        extraTopClasses: "",
        data: [
          {
            text: ins.description,
            title: t("description", null, "capital"),
            value: "description",
          },
        ],
        mediumWidth: 3,
        smallWidth: 6,
      },
      {
        type: "text",
        value: "insurance_provider",
        title: "",
        extraTopClasses: "",
        data: [
          {
            title: t('insurance_provider"', null, "capital"),
            text: ins.insurance_provider,
            value: "insurance_provider",
          },
        ],
        mediumWidth: 1,
        smallWidth: 2,
      },
      {
        type: "text",
        value: "subscription",
        title: "",
        extraTopClasses: "",
        data: [
          {
            text: ins.subscription,
            title: t('subscription"', null, "capital"),
            value: "subscription",
          },
        ],
        mediumWidth: 1,
        smallWidth: 2,
      },
      {
        type: "text",
        value: "payment_cycle",
        title: "",
        extraTopClasses: "",
        data: [
          {
            text: isAbo ? ins.payment_cycle : "",
            title: t('payment_cycle"', null, "capital"),
            value: "payment_cycle",
          },
        ],
        mediumWidth: 1,
        smallWidth: 2,
      },
    ];
    if (isAbo) {
      elements.push({
        type: "numberEdit",
        value: ins.notification_days,
        title: t('notification_days"', null, "capital"),
        extraTopClasses: "",
        extraText: t("days"),
        extraData: ins,
        data: [
          {
            type: "edit",
            text: ins.notification_days,
            extraText: t("days"),
            value: ins.notification_days,
            extraData: ins,
          },
        ],
        mediumWidth: 2,
        smallWidth: 4,
        handler: onNotificationDaysChangedHandler,
      });
    } else {
      elements.push({
        type: "text",
        value: "notification_days",
        title: "",
        extraTopClasses: "",
        data: [
          {
            text: "",
            title: t('notification_days"', null, "capital"),
            value: "",
          },
        ],
        mediumWidth: 2,
        smallWidth: 4,
      });
    }

    if (hasCertificates) {
      elements.push({
        type: "CertificateAddition",
        value: "certificates",
        title: "",
        data: [
          {
            value: "certificates",
            text: "",
            title: "",
            certificates: ins.insurance_certificates,
            id: ins.id,
            insurance: ins,
            dispatch: dispatch,
          },
        ],
        mediumWidth: 12,
        smallWidth: 12,
      });
    }

    if (elements !== []) {
      insuranceData = {
        elements: elements,
        addClasses: addClasses,
        hasCertificates: hasCertificates,
      };
    }
  };

  fillData();
  let insuranceMenu = [];

  return (
    <>
      {insuranceData !== null && (
        <InsuranceListItem
          key={"wti-" + index}
          _key={"wti-" + index}
          listStyle="tight"
          id={"reservations-item-" + insuranceLocal.id}
          overwriteClasses={"inb-c-item row" + insuranceData.addClasses}
          elements={insuranceData.elements}
          insuranceId={insuranceLocal.id}
          insurance={insuranceLocal}
          dispatch={dispatch}
          length={insuranceLocal.insurance_certificates.length}
          certificates={insuranceLocal.insurance_certificates}
          menu={insuranceMenu}
        />
      )}
    </>
  );
};
export default InsuranceItem;
